import React from 'react'
import { Heading } from '@myxplor/ui'

const NoEnrolments = () => <Heading small>No Enrolments found</Heading>

export default NoEnrolments



// WEBPACK FOOTER //
// ./src/care-enrolments/views/empty.jsx